/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Maintenance {
  readonly id?: number;
  /**
   * When the banner starts being displayed.
   */
  startAt: Date;
  /**
   * When the banner stops being displayed.
   */
  endAt: Date;
  readonly message?: string;
  level?: Maintenance.LevelEnum;
}
export namespace Maintenance {
  export type LevelEnum = 'INFO' | 'WARNING' | 'CRITICAL';
  export const LevelEnum = {
    INFO: 'INFO' as LevelEnum,
    WARNING: 'WARNING' as LevelEnum,
    CRITICAL: 'CRITICAL' as LevelEnum,
  };
}
